import { render, staticRenderFns } from "./EmptyNav.vue?vue&type=template&id=0b7018a3&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EmptyNav.vue"
export default component.exports